import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=53f592dc&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f592dc')) {
      api.createRecord('53f592dc', component.options)
    } else {
      api.reload('53f592dc', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=53f592dc&", function () {
      api.rerender('53f592dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBranches/components/ProductCard.vue"
export default component.exports